export const StoreImageCategory = {
  Logo: 'Logo',
  Gallery: 'Gallery',
  ManagementLogo: 'ManagementLogo',
  CustomerLogo: 'CustomerLogo',
  LoginLogo: 'LoginLogo',
  LoginBackground: 'LoginBackground',
  Favicon: 'Favicon',
};

export const STORE_IMAGE_CATEGORY_LOGO = 1;
export const STORE_IMAGE_CATEGORY_GALLERY = 4;
export const STORE_IMAGE_CATEGORY_MANAGEMENT_LOGO = 5;
export const STORE_IMAGE_CATEGORY_CUSTOMER_LOGO = 6;
export const STORE_IMAGE_CATEGORY_LOGIN_LOGO = 7;
export const STORE_IMAGE_CATEGORY_LOGIN_BACKGROUND = 8;
export const STORE_IMAGE_CATEGORY_FAVICON = 9;

export const isStoreLogoImage = (image) => {
  const category = image?.category;
  return category === StoreImageCategory.Logo || category === STORE_IMAGE_CATEGORY_LOGO;
};

export const isStoreGalleryImage = (image) => {
  const category = image?.category;
  return !category || category === StoreImageCategory.Gallery || category === STORE_IMAGE_CATEGORY_GALLERY;
};
